import { apiClient } from './client';
import {
  CreditsResponse,
  CreditPurchaseRequest,
  CreditPurchaseResponse,
} from '../types/api';

export const creditsAPI = {
  // Get user's credit balance and transaction history
  getCredits: async (): Promise<CreditsResponse> => {
    return apiClient.get('/credits');
  },

  // Purchase credits (create Stripe payment intent)
  purchaseCredits: async (data: CreditPurchaseRequest): Promise<CreditPurchaseResponse> => {
    return apiClient.post('/credits', data);
  },

  // Get credit transaction history (part of getCredits, but separate for clarity)
  getTransactionHistory: async (): Promise<CreditsResponse> => {
    return apiClient.get('/credits');
  },
};